import React from 'react';
import ReactSelect from 'react-select';
import styles from './MultiSelect.module.scss';
import { Text } from '../../Typography/Typography';

export interface MultiSelectOption {
  value: string;
  label: string;
}

interface MultiSelectProps {
  label?: string;
  options: MultiSelectOption[];
  value: string[];
  onChange: (values: string[]) => void;
  isClearable?: boolean;
  placeholder?: string;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  label,
  options,
  value,
  onChange,
  isClearable = true,
  placeholder = 'Select...',
}) => {
  const selected = options.filter((opt) => value.includes(opt.value));
  return (
    <div className={styles.container}>
      {label && (
        <label className={styles.labelWrapper}>
          <Text size="small" weight="medium">
            {label}
          </Text>
        </label>
      )}
      <ReactSelect
        isMulti
        classNamePrefix="multi-select"
        className={styles.select}
        options={options}
        value={selected}
        onChange={(vals) => onChange((vals || []).map((v) => (v as MultiSelectOption).value))}
        isClearable={isClearable}
        placeholder={placeholder}
      />
    </div>
  );
};

export default MultiSelect;
